import React, { useState, useEffect } from 'react';
import Header from '../component/Header';
import Sidebar from '../component/Sidebar';
import ChatHistory from '../component/ChatHistory';
import CircularProgress from '@mui/material/CircularProgress';
import { getToken } from '../utils/tokenHelper';

const History = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [chatData, setChatData] = useState([]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const fetchChatHistory = async () => {
            setLoading(true);
            const token = getToken();
            
            if (!token) {
                setError('No token found');
                setLoading(false);
                return;
            }

            const myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Authorization", `Bearer ${token}`);

            try {
                const response = await fetch("https://api.quickcare.ng/api/v1/user/conversations", {
                    method: "GET",
                    headers: myHeaders,
                    redirect: "follow"
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                
                if (result && result.data && Array.isArray(result.data)) {
                    const formattedData = result.data.map(entry => {
                        const date = new Date(entry.date);
                        return {
                            date: date.toISOString().split('T')[0],
                            time: date.toTimeString().split(' ')[0].slice(0, 5),
                            response: entry.response,
                            symptoms: entry.symptoms || 'No symptoms recorded'
                        };
                    });
                    setChatData(formattedData);
                } else {
                    setError("No chat history found");
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError(`Error loading chat history: ${error.message}`);
            } finally {
                setLoading(false);
            }
        };

        fetchChatHistory();
    }, []);

    if (loading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-[#F9FAFB]">
                <div className="text-center">
                    <CircularProgress className="text-[#069125]" />
                    <p className="mt-4 text-gray-600">Loading your chat history...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-[#F9FAFB]">
                <div className="text-center p-4 max-w-md">
                    <div className="text-red-500 mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900">Error loading chat history</h3>
                    <p className="mt-2 text-sm text-gray-600">{error}</p>
                    <button 
                        onClick={() => window.location.reload()} 
                        className="mt-4 px-4 py-2 bg-[#069125] text-white rounded hover:bg-[#057a20] transition-colors"
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
             <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block w-full lg:w-1/6 fixed left-0 top-0 h-full z-50`}>
                <Sidebar toggleSidebar={toggleSidebar} />
            </div>

            {/* Overlay for mobile when sidebar is open */}
            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={toggleSidebar}
                    toggleSidebar={toggleSidebar} 
                    isSidebarOpen={isSidebarOpen}
                ></div>
            )}

            <div className='flex flex-col w-full space-y-4 lg:ml-[16.67%]'>
                <div>
                     <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} 
                     title='Consultation History'
                     />  
                </div>

                <div className='w-full lg:ml-4 lg:flex lg:items-center lg:justify-center'>
                    <ChatHistory chatData={chatData} />
                </div>
            </div>
       </div>
    );
};

export default History;